import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  chooseMethodText: {
    fontSize: 16,
    color: '#003353',
    fontWeight: '600',
    marginTop: 34,
    marginBottom: 16,
    lineHeight: 21,
    alignSelf: 'center',
  },
})
